import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbWebServices } from "abweb/service/AbWebServices";
import { LocaleManager } from "abweb/service/locale/LocaleManager";
import { HelpService } from "abweb/service/onlineHelp/HelpService";
import { computed, makeObservable, observable, override } from "mobx";
export let AbPortalHelpService = (_class = class AbPortalHelpService extends HelpService {
  constructor() {
    super();
    /**
     * Embedded Apps and the main Portal might be using different docuemtation versions. ADS 1.0.1 vs TRW 5.4.1 as an
     * example. We support an override that can be used instead of the version from the server.
     */
    _initializerDefineProperty(this, "_versionOverride", _descriptor, this);
    makeObservable(this);
  }
  set versionOverride(version) {
    this._versionOverride = version;
  }
  get versionOverride() {
    return this._versionOverride;
  }
  get productHelp() {
    return this._productHelp;
  }

  // unlike abweb HelpService, allow overwriting value
  set productHelp(help) {
    this._productHelp = help;
  }
  get whatsNewHelpModule() {
    return this._whatsNewHelpModule;
  }

  // unlike abweb HelpService, allow overwriting value
  set whatsNewHelpModule(help) {
    this._whatsNewHelpModule = help;
  }
  getHelpTopicAbsoluteUrl(topic, options) {
    if (this._versionOverride) {
      return this.getHelpTopicAbsoluteUrlWithVersionOverride(topic);
    }
    return super.getHelpTopicAbsoluteUrl(topic, options);
  }
  getHelpTopicAbsoluteUrlWithVersionOverride(topic) {
    return `${AbWebServices.clientSessionService.abHelpURL}/main/index.jsp?locale=${LocaleManager.languageLocale}&module=aih_${this.versionOverride}&topic=${topic}`;
  }
  get hideTopicLinks() {
    // When we are using a version override, any embedded help link/buttons should not be displayed since those topics
    // generally do not make sense to point to a different version. An example of this is the help button that shows in
    // the QI Admin SQL console, but should not show when the SQL console is embedded in the ADS.
    return this.versionOverride ? true : false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_versionOverride", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "versionOverride", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "versionOverride"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productHelp", [override], Object.getOwnPropertyDescriptor(_class.prototype, "productHelp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "whatsNewHelpModule", [override], Object.getOwnPropertyDescriptor(_class.prototype, "whatsNewHelpModule"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideTopicLinks", [override], Object.getOwnPropertyDescriptor(_class.prototype, "hideTopicLinks"), _class.prototype), _class);
//# sourceMappingURL=AbPortalHelpService.js.map
